import { getUserBonusHistory } from "@actions/bonus";
import Loading from "@components/loading/index.jsx";
import PaginationWrapper from "@pages/profile-v2/pages/bonuses/containers/Pending/Pagination";
import { prepareBonusData } from "@pages/profile-v2/pages/bonuses/helpers";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import NoContent from "../../../history-v2/components/NoContent";
import { BonusWrapper } from "../../elements";
import BonusItem from "./BonusItem";

const Active = ({ getUserBonusHistory, bonusList, lastItem, translate, balance }) => {
	const rootRef = useRef(null);
	const [page, setPage] = useState(0);
	const [openIndex, setOpenIndex] = useState(-1);
	const [loading, setLoading] = useState(false);

	const onPaginate = useCallback(
		(page, cb) => {
			if (page > 0 && lastItem) {
				setLoading(true);
				getUserBonusHistory(
					{ params: { size: 50, lastItem, type: "BonusDeposit" } },
					() => {
						setLoading(false);
						cb();
					}
				);
				setPage(page);
			}
		},
		[lastItem]
	);

	useEffect(() => {
		setLoading(true);
		getUserBonusHistory({ params: { size: 50, type: "BonusDeposit" } }, () => {
			setLoading(false);
		});
	}, []);

	const finalBonusList = prepareBonusData(bonusList, balance);

	return finalBonusList?.length === 0 ? (
		<NoContent
			translate={translate}
			title={"NoInfoText"}
			description={"NoInfoBonus"}
			noBackground={true}
		/>
	) : (
		<div
			style={{ width: "100%" }}
			ref={rootRef}>
			<Loading loading={loading} />
			<PaginationWrapper
				initialBind={true}
				page={page}
				onPaginate={onPaginate}>
				<BonusWrapper>
					{finalBonusList?.map((item, index) => {
						const isBonus = item.type === "Bonus";
						return (
							<BonusItem
								key={item.transactionId || item.walletId}
								data={item}
								index={index}
								translate={translate}
								openIndex={openIndex}
								setOpenIndex={setOpenIndex}
								isBonus={isBonus}
								fsBonusData={item.matchingBonus}
								walletId={item.walletId}
							/>
						);
					})}
				</BonusWrapper>
			</PaginationWrapper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	bonusList: state.bonus.bonusHistory.reports,
	lastItem: state.bonus.bonusHistory.lastItem,
	balance: state.balance.wagering,
});

const mapDispatchToProps = {
	getUserBonusHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Active);
